<template>
    <component
        :is="props.a ? 'a' : props.href ? 'inertia-link' : 'div'"
        class="ui-popover-link"
        :class="[
            active ? 'ui-popover-link--active' : 'ui-popover-link--not-selected',
            isClickable ? 'cursor-pointer' : 'cursor-default',
            selected ? 'ui-popover-link--selected' : '',
            $attrs.class,
        ]"
        :href="props.href"
    >
        <slot name="icon" />
        <span v-if="$slots.icon"><slot /></span>
        <template v-else>
            <slot />
        </template>
    </component>
</template>

<script setup lang="ts">
import { toRef, computed } from 'vue';

interface Props {
    active?: boolean;
    a?: boolean;
    href?: string;
    clickable?: boolean;
    selected?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    active: false,
    a: false,
    href: null,
    clickable: false,
    selected: false,
});

const active = toRef(props, 'active');

const isClickable = computed(() => props.a || props.href || props.clickable);
</script>
